import React, { useEffect, useState } from "react";
import {
  FormControl,
  InputLabel,
  MenuItem,
  Select,
  CircularProgress,
} from "@material-ui/core";
import * as api from "../forecastApi";

export default function SponsorSelect({ tokenData, value, onChange }) {
  const [options, setOptions] = useState([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    const ctrl = new AbortController();
    setLoading(true);
    api
      .fetchSponsorsForCMO({ cmoOrgID: localStorage.collabType === 'CMO' ? tokenData?.organization_id : null},ctrl.signal)
      .then((res) => {
        if (res && res.status) {
          setOptions(res.data || []);
        }
      })
      .catch(() => { })
      .finally(() => setLoading(false));
    return () => ctrl.abort();
  }, []);

  const handleChange = (e) => {
    const id = e.target.value;
    const opt = options.find((o) => o.organizationId === id);
    onChange(id, opt ? opt.organizationName : "");
  };

  return (
    <FormControl fullWidth>
      <InputLabel shrink >
        Select Sponsor <span style={{ color: "red" }}>*</span>
      </InputLabel>
      <Select
        value={value || ""}
        onChange={handleChange}
        disabled={loading}
        displayEmpty
      >
        <MenuItem value="" disabled>
          {loading ? <CircularProgress size={16} /> : "Select Sponsor"}
        </MenuItem>
        {options.map((o) => (
          <MenuItem key={o.organizationId} value={o.organizationId}>
            {o.organizationName}
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  );
}
